export const styleSheet = (theme) => ({
  pointsTabRoot: {
    marginBottom: "16px",
    background: "rgba(255,255,255,0.8)",
    boxShadow: "0px 10px 50px 0px rgba(0,0,0,0.03)",
    border: "none",
    borderRadius: "18px",
    padding: 0,
    marginTop: "-15px",
  },
  pointsTopRIght: {
    marginTop: "-40px",
  },
  pointsTopArea: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  pointsTopLeftCard1: {
    padding: "15px !important",
    minWidth: "184px !important",
    height: "77px !important",
    background: "#eaeaea !important",
    boxShadow: "none !important",
    border: "none !important",
    borderRadius: "18px !important",
    fontWeight: "500  !important",
    fontSize: "25px  !important",
  },
  pointsTopLeftCard2: {
    padding: "15px !important",
    minWidth: "184px !important",
    height: "80px !important",
    background: "rgba(255,255,255,0.8) !important",
    boxShadow: "none !important",
    border: "none !important",
    borderRadius: "18px !important",
    fontWeight: "500  !important",
    fontSize: "25px  !important",
  },
  pointsTopRightCard: {
    padding: "15px !important",
    width: "136px !important",
    height: "136px !important",
    background: "#eaeaea !important",
    boxShadow: "none !important",
    border: "none !important",
    borderRadius: "18px !important",
    fontWeight: "500  !important",
    fontSize: "25px  !important",
  },
  pointsTopRightCardHeading: {
    fontWeight: "400  !important",
    fontSize: "14px  !important",
    textAlign: "center !important",
    marginBottom: "5px !important",
  },
  pointsTopRightCardLink: {
    fontWeight: "400  !important",
    fontSize: "10px  !important",
    textAlign: "center !important",
    textDecoration: "underline !important",
    cursor: "pointer !important",
    textTransform: "uppercase !important",
    color: "#000000 !important",
    marginTop: "10px !important",
  },
  pointsTopRightShieldValue: {
    position: "absolute",
    left: "50%",
    top: "42%",
    transform: "translateY(-50%) translateX(-50%)",
    color: "white",
    fontSize: "20px  !important",
  },
  addPointButton: {
    color: "white !important",
    background: "#0B0909  !important",
    fontSize: "12px  !important",
    boxShadow: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px rgba(0, 0, 0, 0.14), 0px 1px 5px rgba(0, 0, 0, 0.12)",
    height: "32px  !important",
  },
  pointsTopRightShields: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    "& img": {
      height: "60px",
      width: "60px",
    },
  },
  tableRoot: {
    width: "100%",
    marginTop: "20px",
  },
  pointsTabStatsRoot: {
    marginBottom: "16px",
    backgroundColor: "white",
    padding: "10px 15px",
  },
  seeMoreArePoints: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer !important",
    fontSize: "14px  !important",
  },
});
